import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

import { ErrorPageComponent } from '../error-page/error-page.component';

interface UnauthorizedNavigationState {
  returnUrl?: string;
  route?: string;
  userId?: number;
  assetId?: number;
  reason?: string;
}

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslocoModule, ErrorPageComponent],
  host: { class: 'block h-full w-full' },
  templateUrl: './unauthorized.component.html',
})
export class UnauthorizedComponent {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  protected readonly debugInfo = signal<UnauthorizedNavigationState | null>(null);

  constructor() {
    const rawState = this.router.getCurrentNavigation()?.extras?.state;
    const state = isUnauthorizedState(rawState) ? rawState : null;
    this.debugInfo.set(state);
    if (state?.returnUrl && isSafeInternalUrl(state.returnUrl)) {
      this.location.replaceState(state.returnUrl);
    }
  }
}

function isUnauthorizedState(value: unknown): value is UnauthorizedNavigationState {
  return typeof value === 'object' && value !== null;
}

// Same-origin path only: a single leading slash, never a protocol-relative "//host".
function isSafeInternalUrl(url: string): boolean {
  return /^\/(?!\/)/.test(url);
}
